import { RedisCacheObject } from '../provider/RedisProvider';

export function getCurrDeptUserId(cache: RedisCacheObject): number | undefined {
    if (!cache) return undefined;
    if (!cache.Value) return undefined;
    if (!cache.Value.Authorized) return undefined;
    if (!cache.Value.Authorized.HospitalDepartments) return undefined;

    var deptUserId = cache.Value.Authorized.HospitalDepartments.find(hd => hd.Selected)?.UserId;
    return deptUserId ? parseInt(deptUserId, 10) : undefined;
};